import React from 'react';

import { LogoFullDark } from '@/shared/assets/icons/logo/logo-full-dark';
import { LogoFullLight } from '@/shared/assets/icons/logo/logo-full-light';
import { LogoIconDark } from '@/shared/assets/icons/logo/logo-icon-dark';
import { LogoIconLight } from '@/shared/assets/icons/logo/logo-icon-light';
import { LogoTextDark } from '@/shared/assets/icons/logo/logo-text-dark';
import { LogoTextLight } from '@/shared/assets/icons/logo/logo-text-light';
import { LogoWrapper } from '@/shared/components/ui/logo/logo.styled';
import { LogoVariantEnum } from '@/shared/types/common.types';

type LogoProps = {
  variant?: LogoVariantEnum;
  isDarkMode?: boolean;
};

export const Logo: React.FC<LogoProps> = ({ variant, isDarkMode }) => {
  if (variant === LogoVariantEnum.TEXT) {
    return (
      <LogoWrapper>
        {isDarkMode ? <LogoTextDark /> : <LogoTextLight />}
      </LogoWrapper>
    );
  }

  if (variant === LogoVariantEnum.FULL) {
    return (
      <LogoWrapper>
        {isDarkMode ? <LogoFullDark /> : <LogoFullLight />}
      </LogoWrapper>
    );
  }

  return (
    <LogoWrapper>
      {isDarkMode ? <LogoIconDark /> : <LogoIconLight />}
    </LogoWrapper>
  );
};
